module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/zh-hant/2-10e3b6e2f6799dbb69d71f8cea7ea504.jpg";